import React from 'react';
import { Box } from '@mui/material';

function Logo(props) {
  return <Box component="img" alt="Logo" src="/static/logo.svg" {...props} />;
}

export default Logo;
